export const backendUrl = process.env.VUE_APP_BACKEND_API_URL;
export const storageUrl = process.env.VUE_APP_STORAGE_API_URL;
export const adminSecret = process.env.VUE_APP_HEADER_SECRET;
export const cdnUrl = process.env.VUE_APP_CDN_URL;
